const tags = (state) => state.tags;
const tag = (state) => state.tag;

export default {
  tags,
  tag,
};
